// @ts-nocheck
import { lightBlueColor } from "@/constants/colors";
import { css } from "@emotion/react";
import { gotham } from "@/utils/fonts";
import clsx from "clsx";
import { mq } from "@/constants/breakpoints";

// eslint-disable-next-line no-unused-vars
interface NewPricingToggleProps {
  isAnnual: boolean;
  // eslint-disable-next-line no-unused-vars
  onClick: (_isAnnual: boolean) => void;
}

const NewPricingToggle = ({ isAnnual, onClick }: NewPricingToggleProps) => {
  const annualSelected = isAnnual;

  return (
    <div
      css={css`
        min-width: 100%;
        width: 100%;
        ${mq["lg"]} {
          min-width: 202px;
        }
      `}
    >
      <div
        css={css`
          border-radius: 15px;
          border: 2px solid #daf2ff;
          background: #fff;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          padding: 15px;
          gap: 14px;
          box-sizing: border-box;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
          ${mq["lg"]} {
            inline-flex;
            width: fit-content;
            flex-direction: column;
            gap: 10px;
          }
        `}
      >
        <button
          type="button"
          onClick={() => onClick(true)}
          className={clsx(gotham.className)}
          css={css`
            display: flex;
            align-items: center;
            justify-content: center;
            border: none;
            outline: none;
            background: ${annualSelected ? lightBlueColor : "transparent"};
            color: ${annualSelected ? "#fff" : lightBlueColor};
            border-radius: 10px;
            padding: 16px 46px;
            transition: background 0.2s, color 0.2s;
            cursor: pointer;
          `}
        >
          Pay Annually
        </button>
        <button
          type="button"
          onClick={() => onClick(false)}
          className={clsx(gotham.className)}
          css={css`
            display: flex;
            align-items: center;
            justify-content: center;
            border: none;
            outline: none;
            background: ${!annualSelected ? lightBlueColor : "transparent"};
            color: ${!annualSelected ? "#fff" : lightBlueColor};
            border-radius: 10px;
            padding: 16px 43px;
            transition: background 0.2s, color 0.2s;
            cursor: pointer;
          `}
        >
          Pay Monthly
        </button>
      </div>
    </div>
  );
};

export default NewPricingToggle;
